import React, {useEffect} from "react";
import { motion } from "framer-motion";
import { overlayMotion } from "../../data/MotionVars";
import {fireViewStartCustomEvent, fireViewEndCustomEvent, fireActionTriggerCustomEvent} from '../../utils/adobe-launch'
import { pageNameConverter} from '../../utils/storeConverter';
import {useBeforeFirstRender} from '../../hooks/customHooks'

import { getStore } from "../../data/Stores";

import MyBooks from "../MyBooks/MyBooks";
import MyQuiz from "../MyQuiz/MyQuiz";
import MyVideo from "../MyVideo/MyVideo";
import MyGame from '../MyGame/MyGame'

import "./ActivityHolder.css";

const addActivity = (
  activity,
  store,
  playerObj,
  handleDisposePlayer,
  changePlayerObj,
) => {
  switch (activity) {
    case "book":
      return (
        <MyBooks
          handleDisposePlayer={handleDisposePlayer}
          storeId={store.id}
          books={store.books}
          activity={activity}
        />
      );
    case "quiz":
      return (
        <MyQuiz
          handleDisposePlayer={handleDisposePlayer}
          storeId={store.id}
          quiz={store.quiz}
          activity={activity}
        />
      );
    case "video":
      return (
        <MyVideo
          storeId={store.id}
          playerObj={playerObj}
          handleDisposePlayer={handleDisposePlayer}
          changeVideoPlayerObj={changePlayerObj}
          videos={store.videos}
          activity={activity}
        />
      );
    case "game":
      return (
        <MyGame storeId={store.id} activity={activity} game={store.game} />
      )
    default:
      console.log("Activity issue");
  }
};

function ActivityHolder({location, match, videoPlayerObject, changeVideoPlayerObject }) {

  const splitPath = location.pathname.split("/");
  const page_name = pageNameConverter(splitPath);

  const handleUpdateDataLayer = (data) => {
    console.log("the digitalData: ", data);
    window.digitalData.pageInfo = data;
  };

  useBeforeFirstRender( () => {
    handleUpdateDataLayer({
      page_name: page_name,
      page_title: "courtney: orange valley mall",
      game_name: "courtney",
      site_country: "us",
      site_language: "en",
    });
    fireViewStartCustomEvent({ page_name: page_name });
  })

  useEffect(() => {
    // console.log('this is the component did mount. sort of: ', location)
    fireViewEndCustomEvent();
  }, [])
  const { id, activity } = match.params;
  const store = getStore(id);

  const handleDisposePlayer = () => {
    if (videoPlayerObject) {
      console.log("handle dispose player was called")
      videoPlayerObject.dispose();
      changeVideoPlayerObject(null);
    }
  };

  return (
    <motion.section {...overlayMotion} className="activityBG">
      <div className={`activityHolder activityHolder${store.id}`}>
        {addActivity(
          activity,
          store,
          videoPlayerObject,
          handleDisposePlayer,
          changeVideoPlayerObject,
          
        )}
      </div>
    </motion.section>
  );
}

export default ActivityHolder;
